import { useState, useEffect } from "react";
import Select from "react-select";
import { twdClass } from "../../../constants/tailwind.constants";
import { processBracesValues } from "../../../utils/common.utils";
import { cloneDeep, findIndex, find } from "lodash";
import { Button, BtnStyle, BtnBack, BtnAdd, BtnNext} from "../../ui/com_ui";


export const RspMapColumns = ({
  columnNames=[],
  mapColumnsLabel = 'Map Columns:',
  updateProp = 'text',
  textValue='',
  data={},
  onUpdate=()=>{}
}) => {
  //console.log("data", data[updateProp], data )
  const optionList = columnNames.map((itm) => ({
    value: itm.key,
    label: itm.value,
  }));

  let defaultValues = processBracesValues(data[updateProp]).map((itm) => {
    return optionList.filter((item) => itm.value === item.label)[0];
  });

  
  const prepareText = (items) => {
    let mTextValue = textValue.trim();
    processBracesValues(mTextValue).forEach((itm) => {
      const isValue = items.filter((flt) => itm.value === flt.label);
      if (isValue.length === 0) {
        mTextValue = mTextValue.replace(`[[${itm.value}]]`, "");
      }
    });
    const addedText =
      mTextValue +
      items
        .map((itm) => {
          const value = `[[${itm.label}]]`;
          if (!mTextValue.includes(value)) {
            return value;
          }
          return "";
        })
        .join(" ");
    setProcessTextValue(addedText, items);
    // updateValues("params", items, section.id);
  };

  const setProcessTextValue = (text, items) => {
    const d = cloneDeep(data);
    let params = ''
    if(updateProp =='text') {
      params = 'params'
    }else if(updateProp) {
      params = updateProp+'_params'
    }else{
      params = 'params'
    }
    if (items) {
      d[params] = items;
    }
    d.text = text;
    onUpdate(d, d[params])
    //sec[updateProp] = text
    //setTextValue(text);
    //console.log("Process", sec, text)
    //updateValues(section.id, sec);
  };

  return (
    <div className={twdClass("items-start mb-4")}>
      <div className={twdClass("w-36 text-sm opacity-75 mb-2")}>{mapColumnsLabel}</div>
      <div className={twdClass("w-full text-xs rounded-full")}>
        <Select
          isMulti
          name="text-element"
          defaultValue={defaultValues}
          options={optionList}
          onChange={(value) => {
            prepareText(value);
          }}
          styles={{
            control: (baseStyles, state) => ({
              ...baseStyles,
              borderRadius:'20px',                
            }),
          }}
        />
      </div>
    </div>
  );
};
